import type {
  CategoriesResponse,
  HomeResponse,
  PageResponse,
  ProductDetailResponse,
  ProductListResponse,
} from './types'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL as string

async function getJson<T>(path: string): Promise<T> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    headers: { Accept: 'application/json' },
  })

  if (!response.ok) {
    throw new Error(`Catalog API request failed: ${path} (${response.status})`)
  }

  return response.json() as Promise<T>
}

export function getHome() {
  return getJson<HomeResponse>('/home')
}

export function getContentPage(template: string) {
  return getJson<PageResponse>(`/pages/${template}`)
}

export function getCategories() {
  return getJson<CategoriesResponse>('/categories')
}

export function getProducts(categoryId?: number | string, page?: number) {
  const params = new URLSearchParams()
  if (categoryId) params.set('category', String(categoryId))
  if (page && page > 1) params.set('page', String(page))
  const query = params.toString()
  return getJson<ProductListResponse>(`/products${query ? `?${query}` : ''}`)
}

export function getProductDetail(slug: string) {
  return getJson<ProductDetailResponse>(`/products/${encodeURIComponent(slug)}`)
}

export async function submitAffiliateRequest(data: Record<string, string>) {
  const response = await fetch(`${API_BASE_URL}/affiliate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    throw new Error(`Affiliate request failed (${response.status})`)
  }

  return response.json() as Promise<{ success: boolean }>
}
